// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://atqgojjqmixeqjixoupo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF0cWdvampxbWl4ZXFqaXhvdXBvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU1NTQ3MjAsImV4cCI6MjA2MTEzMDcyMH0.uWNxViooBrRMSXGMHRMN8Qb21Advwm3_e0FVEU3qKPs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Create the Supabase client with additional configuration
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
  global: {
    headers: {
      'x-application-name': 'the-resume-boost'
    }
  }
});

// Add a debug function to check session
export const debugSession = async () => {
  try {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) throw error;
    return session;
  } catch (error) {
    console.error('Session debug error:', error);
    return null;
  }
};